import { createLogic } from "redux-logic";
import { isEmpty } from "lodash";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as IntegrationActions from "../../actions/integrationActions";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const loadIntegrationsLogic = createLogic({
	type: ActionTypes.LOAD_INTEGRATIONS,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(ControlPanelActions.showLoading());

		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(async token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				try {
					let identities = await api.get(`/apps/${action.appKey}/integrations`);
					let oauthIntegrations = await api.get(`/apps/${action.appKey}/oauth`);

					const data = [...identities.data, ...oauthIntegrations.data];

					dispatch(ControlPanelActions.hideLoading());
					dispatch(IntegrationActions.loadIntegrationsSuccess(data));
				} catch (error) {
					dispatch(ControlPanelActions.hideLoading());
					dispatch(IntegrationActions.loadIntegrationsFail(error));
				} finally {
					done();
				}
			});
	},
});

export default [loadIntegrationsLogic];
